import React from 'react';
import { createPortal } from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import LogsChatAssistantBox from './LogsChatAssistantBox';
import {
  closeLogsChat,
  selectLogsChatIsOpen,
  selectLogsChatSessionId,
  selectLogsChatPhone,
  selectLogsChatTo,
  selectLogsChatFrom
} from '../../../Redux/Reducer/logsChatAssistant';

export default function GlobalLogsChatAssistant() {
  const dispatch = useDispatch();
  const isOpen = useSelector(selectLogsChatIsOpen);
  const sessionId = useSelector(selectLogsChatSessionId);
  const phone = useSelector(selectLogsChatPhone);
  const to = useSelector(selectLogsChatTo);
  const from = useSelector(selectLogsChatFrom);

  // Render nothing if closed (keeps DOM clean)
  if (!isOpen) return null;

  return createPortal(
    <LogsChatAssistantBox
      isOpen={isOpen}
      onClose={() => dispatch(closeLogsChat())}
      sessionId={sessionId}
      phoneForQuery={phone}
      toNumber={to}
      fromNumber={from}
    />,
    document.body
  );
}
